export function SkipLink() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-white focus:text-blue-600 focus:shadow-lg focus:rounded-lg focus:font-medium focus:outline-none focus:ring-2 focus:ring-blue-600"
    >
      Skip to main content
    </a>
  )
}
